import { BasePoI, TypePOI } from "../backend/backendapi";

export class MapPoint {
    id: string | undefined;
    type: TypePOI | undefined;
    accountId: number | undefined;
    center: any | null;
    custom: boolean | undefined;
    draggable: boolean | undefined;
    color: string | undefined;
    popup: boolean | undefined;
    popuptext: string | undefined;
    poi: BasePoI | undefined;
    history: LngLatDate[] | undefined;
}

export type LngLatDate = {
    lng: number;
    lat: number;
    date: Date;
}